import config from "react-global-configuration";

const isDevelopmentBuild = process.env.NODE_ENV === "development";

const developmentDefaults = {
  url: "http://localhost:4004",
  auth: "http://sigtrein4.test:1282",
  api: "http://sigtrein4.test:1282/api",
  cdn: "http://sigtrein4.test:1292",
  api_sigmec: "http://sigmec4.test:1281/api",
  cdn_sigmec: "http://sigmec4.test:1291",
  api_sigtrip: "http://sigtrip4.test:1280/api",
  cdn_sigtrip: "http://sigtrip4.test:1290",
  control: "http://localhost:4005",
  exam: "http://localhost:4006",
  refresh_time: 20,
};

const getEnvValue = (name, fallback = "") => {
  const value = process.env[name];

  if (typeof value !== "undefined" && value !== "") {
    return value;
  }

  return fallback;
};

const getBooleanEnvValue = (name, fallback = false) => {
  const value = process.env[name];

  if (typeof value === "undefined" || value === "") {
    return fallback;
  }

  return ["1", "true", "yes", "on"].includes(String(value).toLowerCase());
};

const getNumberEnvValue = (name, fallback) => {
  const value = process.env[name];

  if (typeof value === "undefined" || value === "") {
    return fallback;
  }

  const parsedValue = Number(value);

  return Number.isNaN(parsedValue) ? fallback : parsedValue;
};

const apiUrl = getEnvValue("REACT_APP_API", isDevelopmentBuild ? developmentDefaults.api : "");
const authUrl = getEnvValue(
  "REACT_APP_AUTH",
  apiUrl ? apiUrl.replace(/\/api$/, "") : (isDevelopmentBuild ? developmentDefaults.auth : "")
);

const globals = {
  url: getEnvValue("REACT_APP_URL", isDevelopmentBuild ? developmentDefaults.url : ""),
  auth: authUrl,
  api: apiUrl,
  cdn: getEnvValue("REACT_APP_CDN", isDevelopmentBuild ? developmentDefaults.cdn : ""),
  api_sigmec: getEnvValue("REACT_APP_API_SIGMEC", isDevelopmentBuild ? developmentDefaults.api_sigmec : ""),
  cdn_sigmec: getEnvValue("REACT_APP_CDN_SIGMEC", isDevelopmentBuild ? developmentDefaults.cdn_sigmec : ""),
  api_sigtrip: getEnvValue("REACT_APP_API_SIGTRIP", isDevelopmentBuild ? developmentDefaults.api_sigtrip : ""),
  cdn_sigtrip: getEnvValue("REACT_APP_CDN_SIGTRIP", isDevelopmentBuild ? developmentDefaults.cdn_sigtrip : ""),
  control: getEnvValue("REACT_APP_CONTROL", isDevelopmentBuild ? developmentDefaults.control : ""),
  exam: getEnvValue("REACT_APP_EXAM", isDevelopmentBuild ? developmentDefaults.exam : ""),
  refresh_time: getNumberEnvValue("REACT_APP_REFRESH_TIME", developmentDefaults.refresh_time),
  development: getBooleanEnvValue("REACT_APP_DEVELOPMENT", isDevelopmentBuild),
  client_id: getEnvValue("REACT_APP_CLIENT_ID", ""),
  client_secret: getEnvValue("REACT_APP_CLIENT_SECRET", ""),
};

if (process.env.NODE_ENV === "production") {
  ["url", "api", "cdn"].forEach((key) => {
    if (!globals[key]) {
      console.warn(`SIGTREIN Client: missing configuration for "${key}".`);
    }
  });
}

config.set({
  ...globals,
});

class Globals {}

export default Globals;



// WEBPACK FOOTER //
// ./src/Components/Miscelania/Globals.js